export default __webpack_public_path__ + "static/media/exceptionalities.714a58d7.jpg";